module.exports = __webpack_public_path__ + "static/img/bbc-benefit3.4f8e148.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bbc-benefit3.png
// module id = 1072
// module chunks = 1